import React, { useState } from "react";
import { motion } from "framer-motion";
import CoinRainGame from "./CoinRainGame";

const CoinRainTaskModal = ({ onClose }) => {
  const [showGame, setShowGame] = useState(false);

  if (showGame) {
    return <CoinRainGame />;
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
   className="fixed inset-0 z-50 flex items-center justify-center bg-[#050D1A]/90 backdrop-blur-md p-3 sm:p-5 overflow-y-auto"
    >
      <motion.div
        initial={{ y: 30, scale: 0.95 }}
        animate={{ y: 0, scale: 1 }}
        transition={{ duration: 0.35 }}
        className="w-full max-w-lg overflow-hidden rounded-3xl border border-yellow-500/20 bg-[#0B172A] shadow-[0_0_40px_rgba(234,179,8,.12)]"
      >
        {/* Header */}
        <div className="border-b border-slate-700 p-8 text-center">

          <div className="mx-auto mb-8 flex h-28 w-28 items-center justify-center rounded-3xl bg-gradient-to-br from-yellow-400 to-yellow-600 shadow-[0_0_35px_rgba(234,179,8,.35)]">
            <span className="text-5xl font-black text-[#050D1A]">₿</span>
          </div>

          <h2 className="text-3xl font-extrabold text-white">
            Coin Rain Challenge
          </h2>

          <p className="mt-3 text-slate-400">
            Catch the correct coins and earn your daily reward.
          </p>
        </div>

        {/* Rules */}
        <div className="space-y-5 p-8">
{/* 
          <div className="rounded-2xl border border-slate-700 bg-[#08111F] p-5">

            <h3 className="mb-4 text-lg font-bold text-yellow-400">
              Game Rules
            </h3>

            <div className="space-y-3 text-slate-300">

              <div className="flex items-center gap-3">
                <div className="h-2 w-2 rounded-full bg-yellow-400" />
                <p>Coins continuously fall from the top.</p>
              </div>

              <div className="flex items-center gap-3">
                <div className="h-2 w-2 rounded-full bg-blue-500" />
                <p>
                  Tap only
                  <span className="ml-1 font-bold text-yellow-400">
                    Bitcoin Coins
                  </span>
                </p>
              </div>

              <div className="flex items-center gap-3">
                <div className="h-2 w-2 rounded-full bg-green-500" />
                <p>Reach 100 points within 60 seconds.</p>
              </div>

            </div>

          </div> */}

          {/* Reward */}
          <div className="rounded-2xl border border-yellow-500/30 bg-yellow-500/10 p-5 text-center">

            <p className="text-sm uppercase tracking-widest text-yellow-400">
              Daily Reward
            </p>

            <h3 className="mt-2 text-4xl font-black text-white">
              50 Points
            </h3>

          </div>

          {/* Button */}
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.97 }}
            onClick={() => setShowGame(true)}
            className="w-full rounded-2xl bg-gradient-to-r from-yellow-400 to-yellow-500 py-4 text-lg font-bold text-[#050D1A] shadow-[0_0_25px_rgba(234,179,8,.35)] transition-all hover:shadow-[0_0_35px_rgba(234,179,8,.5)]"
          >
            Start Challenge
          </motion.button>

       

        </div>
      </motion.div>
    </motion.div>
  );
};

export default CoinRainTaskModal;